/**
 * @see componentDidMount in DocumentContainer.js about how to use this api
 */
export default element => {
  window.documentViewer.setScrollViewElement(element);
};
